(() => {
  const root = document.querySelector('[data-sg-cro]');
  if (!root) return;
  const labels = JSON.parse(root.querySelector('[data-sg-cro-labels]').textContent);
  const media = root.querySelector('.product__media-wrapper');
  const gallery = root.querySelector('media-gallery');
  const mobile = window.matchMedia('(max-width: 749px)');
  const photosFirst = root.dataset.sgCroLayout === 'photos_first';
  const designOrder = ['5', '915', '95', '951', '918', '913', '94', '923', '70', '93', '912', '99'];
  document.documentElement.classList.add('sg-cro-page');
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-sg-photo-button]');
    if (!button) return;
    root.classList.remove('sg-cro-personalizing');
    root.querySelectorAll('[data-sg-photo]').forEach(photo => photo.hidden = photo.dataset.sgPhoto !== button.dataset.sgPhotoButton);
    root.querySelectorAll('[data-sg-photo-button]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
  root.querySelectorAll('[data-sg-packs]').forEach(button => button.addEventListener('click', () => {
    const input = root.querySelector('.custom-qty-wrapper input[name="quantity"]');
    if (!input) return;
    input.value = button.dataset.sgPacks;
    if (window.setZeptoQuantity) window.setZeptoQuantity(Number(input.value));
    input.dispatchEvent(new Event('change', {bubbles: true}));
  }));
  root.addEventListener('change', () => {
    const quantity = root.querySelector('.custom-qty-wrapper input[name="quantity"]')?.value;
    root.querySelectorAll('[data-sg-packs]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.sgPacks === quantity)));
  });
  let installed = false;
  let preview;
  let app;
  let design;
  let frame;
  let visible = false;
  let lastFrame = 0;
  function render(now) {
    frame = undefined;
    if (!visible || document.hidden) return;
    if (now - lastFrame > 120) {
      const source = document.querySelector('canvas#pplr_canvas');
      if (source?.width && source.height) {
        const destination = preview.querySelector('canvas');
        const context = destination.getContext('2d');
        context.clearRect(0, 0, destination.width, destination.height);
        context.drawImage(source, 0, 0, destination.width, destination.height);
        lastFrame = now;
      }
    }
    frame = requestAnimationFrame(render);
  }
  function startRendering() {
    if (visible && !frame && !document.hidden) frame = requestAnimationFrame(render);
  }
  document.addEventListener('visibilitychange', startRendering);
  function placePreview() {
    if (mobile.matches) app.parentElement.before(preview);
    else media.append(preview);
    if (!photosFirst) {
      const illustrations = root.querySelector('[data-sg-showcase]');
      const form = root.querySelector('product-form');
      if (mobile.matches && form) form.after(illustrations);
      else media.append(illustrations);
    }
  }
  function install() {
    if (installed) return;
    app = root.querySelector('.product-personalizer');
    if (!app || !root.querySelector('canvas#pplr_canvas')) return;
    installed = true;
    const showcase = root.querySelector('[data-sg-showcase-template]');
    media.append(showcase.content.cloneNode(true));
    const designField = app.querySelector('.pplr-wrapper[data-main="2"]');
    design = designField?.querySelector('.pplr-swatch-main');
    if (design) {
      designField.classList.add('sg-cro-designs');
      design.querySelectorAll('.pplr-swatch-element').forEach((item, index) => {
        const value = item.getAttribute('data-val') || item.getAttribute('data-value');
        const rank = designOrder.indexOf(value);
        item.style.order = rank < 0 ? designOrder.length + index : rank;
        if (rank >= 0) item.dataset.sgFeatured = 'true';
      });
      const label = designField.querySelector('.oindexlabel');
      if (label) label.textContent = labels.designLabel;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sg-cro-toggle';
      button.textContent = labels.showDesigns;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = designField.classList.toggle('sg-cro-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? labels.hideDesigns : labels.showDesigns;
      });
      design.after(button);
    }
    const textField = app.querySelector('.pplr-wrapper[data-main="3"]');
    const textLabel = textField?.querySelector('.pplrlabel');
    if (textLabel?.firstChild?.nodeType === Node.TEXT_NODE) textLabel.firstChild.textContent = labels.textLabel + ' ';
    const colorLabel = app.querySelector('.pplr-wrapper[data-main="5"] .pplrlabel');
    if (colorLabel?.firstChild?.nodeType === Node.TEXT_NODE) colorLabel.firstChild.textContent = labels.colorLabel + ' ';
    preview = document.createElement('div');
    preview.className = 'sg-cro-preview';
    const canvas = document.createElement('canvas');
    canvas.width = 720;
    canvas.height = 720;
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', labels.preview);
    const copy = document.createElement('div');
    copy.className = 'sg-cro-preview-copy';
    const title = document.createElement('p');
    title.className = 'sg-cro-preview-label';
    title.textContent = labels.preview;
    const hint = document.createElement('p');
    hint.className = 'sg-cro-preview-hint';
    hint.textContent = labels.previewHint;
    copy.append(title, hint);
    preview.append(copy, canvas);
    placePreview();
    mobile.addEventListener('change', placePreview);
    root.classList.add('sg-cro-ready');
    if (photosFirst) gallery.setAttribute('aria-hidden', 'true');
    else gallery.removeAttribute('aria-hidden');
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      startRendering();
    }).observe(preview);
    app.addEventListener('focusin', () => {
      root.classList.add('sg-cro-personalizing');
      startRendering();
    });
    app.addEventListener('input', () => {
      root.classList.add('sg-cro-personalizing');
      startRendering();
    });
    app.addEventListener('pointerdown', () => {
      root.classList.add('sg-cro-personalizing');
      startRendering();
    });
    app.querySelector('.pplr-wrapper[data-main="8"]')?.addEventListener('click', () => {
      const savedY = window.scrollY;
      const until = performance.now() + 800;
      let cancelled = false;
      const cancel = () => { cancelled = true; };
      window.addEventListener('wheel', cancel, {once: true, passive: true});
      window.addEventListener('touchmove', cancel, {once: true, passive: true});
      window.addEventListener('keydown', cancel, {once: true});
      function preserve(now) {
        if (!cancelled && now < until) {
          if (Math.abs(window.scrollY - savedY) > 2) window.scrollTo({top: savedY, behavior: 'instant'});
          requestAnimationFrame(preserve);
        } else {
          window.removeEventListener('wheel', cancel);
          window.removeEventListener('touchmove', cancel);
          window.removeEventListener('keydown', cancel);
        }
      }
      requestAnimationFrame(preserve);
    }, true);
  }
  const observer = new MutationObserver(install);
  observer.observe(root, {childList: true, subtree: true});
  install();
  setTimeout(() => observer.disconnect(), 30000);
})();
